module.exports = __webpack_public_path__ + "img/icon-four@3x1.da5ead2c.png";